import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getOrderById, getOrderInvoice } from "../api";

const OrderDetails = () => {
  const { orderId } = useParams();

  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOrder();
  }, [orderId]);
  const IMAGE_URL =
    process.env.NODE_ENV === "production"
      ? "https://polybionictechnologies.com"
      : "http://localhost:5001";
  const fetchOrder = async () => {
    try {
      const res = await getOrderById(orderId);
      console.log(res,"resresresresresresresresresresres")

      if (res?.data?.success) {
        console.log("ORDER:", res.data.order);
        setOrder(res.data.order);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  const handleDownloadInvoice = async () => {
    try {
      const response = await getOrderInvoice(order.orderId);

      const url = window.URL.createObjectURL(new Blob([response.data]));

      const link = document.createElement("a");

      link.href = url;

      link.download = `${order.invoiceNumber || order.orderId}.pdf`;

      document.body.appendChild(link);

      link.click();

      link.remove();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Invoice Download Error:", error);
    }
  };
  const getStatusColor = (status) => {
    switch (status) {
      case "Delivered":
        return "text-green-600";
      case "Return Requested":
        return "text-orange-600";
      case "Cancelled":
        return "text-red-600";
      default:
        return "text-blue-600";
    }
  };

  if (loading) {
    return <div className="p-6 text-lg font-semibold">Loading...</div>;
  }

  if (!order) {
    return (
      <div className="p-6 text-red-500 text-lg font-semibold">
        Order Not Found
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-green-600 to-emerald-500 p-6 text-white">
          <h1 className="text-3xl font-bold">Order Details</h1>

          <p className="mt-2">Order ID: {order.orderId}</p>

          <p className="text-green-100 text-sm mt-1">
            {new Date(order.createdAt).toLocaleString()}
          </p>

          <div className="mt-4">
            <button
              onClick={handleDownloadInvoice}
              className="bg-white text-green-700 px-4 py-2 rounded-lg font-semibold hover:bg-gray-100"
            >
              Download Invoice
            </button>
          </div>
        </div>

        {/* Summary */}
        <div className="grid lg:grid-cols-5 md:grid-cols-2 gap-4 p-6">
          <div className="bg-blue-50 rounded-xl p-4">
            <p className="text-gray-500 text-sm">Order Status</p>

            <h3 className={`font-bold text-lg ${getStatusColor(order.status)}`}>
              {order.status}
            </h3>
          </div>

          <div className="bg-yellow-50 rounded-xl p-4">
            <p className="text-gray-500 text-sm">Payment Status</p>

            <h3 className="font-bold text-yellow-600 text-lg">
              {order.paymentStatus}
            </h3>
          </div>

          <div className="bg-indigo-50 rounded-xl p-4">
            <p className="text-gray-500 text-sm">Payment Method</p>

            <h3 className="font-bold text-indigo-600 text-lg">
              {order.paymentMethod}
            </h3>
          </div>

          <div className="bg-green-50 rounded-xl p-4">
            <p className="text-gray-500 text-sm">Total Amount</p>

            <h3 className="font-bold text-green-600 text-lg">
              ₹{order.amount}
            </h3>
          </div>

          <div className="bg-purple-50 rounded-xl p-4">
            <p className="text-gray-500 text-sm">Total Items</p>

            <h3 className="font-bold text-purple-600 text-lg">
              {order.items?.length || 0}
            </h3>
          </div>
        </div>

        {/* Customer Information */}
        <div className="px-6 pb-6">
          <div className="border rounded-2xl p-5">
            <h2 className="text-xl font-semibold mb-4">Customer Information</h2>

            <div className="grid md:grid-cols-2 gap-5">
              <div>
                <p className="text-gray-500">Full Name</p>

                <p className="font-semibold">
                  {order.shippingAddress?.name || "-"}
                </p>
              </div>

              <div>
                <p className="text-gray-500">Phone Number</p>

                <p className="font-semibold">
                  {order.shippingAddress?.phone || "-"}
                </p>
              </div>

              <div>
                <p className="text-gray-500">Email</p>

                <p className="font-semibold">
                  {order.shippingAddress?.email || "-"}
                </p>
              </div>

              <div>
                <p className="text-gray-500">Pincode</p>

                <p className="font-semibold">
                  {order.shippingAddress?.pincode || "-"}
                </p>
              </div>

              <div className="md:col-span-2">
                <p className="text-gray-500">Address</p>

                <p className="font-semibold">
                  {order.shippingAddress?.address},{" "}
                  {order.shippingAddress?.city}, {order.shippingAddress?.state}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Products */}
        <div className="px-6 pb-6">
          <h2 className="text-xl font-semibold mb-4">Ordered Products</h2>

          <div className="space-y-4">
            {order.items?.map((item, index) => (
              <div
                key={index}
                className="border rounded-2xl p-5 flex flex-col md:flex-row gap-5 hover:shadow-lg transition"
              >
                <img
                  src={
                    item.image?.startsWith("http")
                      ? item.image
                      : `${IMAGE_URL}/uploads/${item.image}`
                  }
                  alt={item.title}
                  className="w-28 h-28 object-cover rounded-xl border"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/no-image.png";
                  }}
                />

                <div className="flex-1">
                  <h3 className="text-xl font-semibold">{item.title}</h3>

                  <p className="text-gray-600 mt-2">
                    Category: {item.category}
                  </p>

                  <p className="text-gray-600">Brand: {item.brand}</p>

                  <p className="text-gray-600">Quantity: {item.quantity}</p>

                  <p className="text-green-600 font-bold text-2xl mt-2">
                    ₹{item.price}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderDetails;
